import { gql } from 'graphql-request';

export const GET_AUDITION_SCHEDULES = gql`
  query ($first: Int, $after: String, $phase: String!, $status: String, $search: String) {
    talent_audition_schedules_connection(
      first: $first
      after: $after
      phase: $phase
      status: $status
      search: $search
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      nodes {
        cd_rescheduled
        self_tapes_requirement_revision
        id
        phase
        status
        main
        checked_in_at
        updated_at
        mediumable_count
        medium_attachments {
          id
          attachment
          modified_attachment
          sort
          tag_list
          primary
          medium {
            file_type
            file_name
            file_size
            file_width
            file_height
          }
        }
        schedule {
          id
          time_in
          time_out
          casting_session {
            casting_location {
              address {
                timezone
              }
            }
          }
        }
        audition {
          id
          sequence_tag
          profile {
            id
            talent {
              first_name
              last_name
            }
            casting_private
            agency {
              id
              name
              country
              state
              full_name
            }
          }
          casting_role {
            id
            audition
            name
            self_tapes_requirements
            project {
              id
              name
              union
              logo
              company {
                name
                addresses {
                  primary
                  location_name
                  address1
                  city_suburb
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_SPECIFIC_AUDITION_SCHEDULE = gql`
  query ($id: ID!) {
    audition_schedule(id: $id) {
      id
      phase
      status
      main
      checked_in_at
      mediumable_count
      answers {
        answer
        question {
          inquiry
        }
      }
      request_note
      declined_note
      reschedule_note
      audition {
        id
        sequence_tag
        priority
        submission_note {
          comment
          updated_at
          created_at
        }
        mediumable_count
        internal_note_count
        public_note_count
        internal_rating
        public_rating
        profile {
          talent {
            first_name
            last_name
          }
          agency {
            id
            name
            country
            state
          }
          primary_medium_attachment {
            modified_attachment
          }
        }
        casting_role {
          wardrobe
          medium_attachments {
            id
            attachment
            mediumable_id
            mediumable_type
            modified_attachment
            medium {
              id
              file_name
              file_type
              file_size
            }
          }
          talent_note
          reference_urls
          photos {
            id
            attachment
            modified_attachment
            medium {
              file_name
              file_height
              file_width
            }
          }
          sides {
            id
            attachment
            modified_attachment
            medium {
              file_name
              file_height
              file_width
              file_type
            }
          }
          rate_information
          #role_description
          agents_clients_description
          activity_dates
          talent_description
          id
          name
          audition
          callback
          fitting
          working
          age_range_from
          age_range_to
          submission_date_due
          submission_date_timezone
          submission_notes
          spot_name
          audition_type
          principal_role_type
          background_role_type
          rate_summary
          genders
          ethnic_appearance
          paying_role
          self_tapes_requirements
          self_tapes_directions
          role_is_for
          project {
            self_tapes_note
            id
            name
            project_type
            sag_aftra_contract_type
            union
            conflicts
            conflicts_details
            usage
            additional_provisions
            additional_details
            production_company
            director
            producer
            ad_agency
            rate
            contact_email
            contact_number
            contact_attachments {
              visible_to_agents
              contactable_type
              contactable_id
              contact {
                id
                position
                user {
                  first_name
                  last_name
                }
              }
            }
            medium_attachments {
              id
              attachment
              mediumable_id
              mediumable_type
              modified_attachment
              medium {
                id
                file_name
                file_type
                file_size
              }
            }
            staff_attachments {
              position
              staff {
                position_name
                user {
                  first_name
                  last_name
                }
              }
            }
            company {
              name
              addresses {
                primary
                location_name
                address1
                city_suburb
              }
            }
            rehearsal_dates
            travel_dates
            weatherhold_dates
            proposed_on_air_dates
            additional_fees
            talent_fees
            activity_dates
            options
            logo
            terms
            performance_fee_details
            fitting
            working
          }
        }
      }
      schedule {
        id
        time_in
        time_out
        casting_session {
          request_note
          new_talent_note
          cancelled_note
          pending_note
          wardrobe_note
          zoom_meeting_url
          name
          meeting_id
          meeting_password
          audition_type

          casting_location {
            address {
              timezone
              zip_code
              country_code
              full_address
            }
          }
        }
      }
      medium_attachments {
        id
        attachment
        modified_attachment
        sort
        mediumable_id
        mediumable_type
        tag_list
        primary
        medium {
          file_type
          file_name
          file_size
          file_width
          file_height
        }
      }
      audition_schedule_groups {
        id
        group_name
        group_number
      }
      public_notes {
        id
        flag_type
        rating
        comment
        user {
          id
          first_name
          last_name
        }
      }
    }
  }
`;

export const GET_AUDITION_REQUEST = gql`
  query ($first: Int, $after: String, $status: String, $phase: String) {
    audition_schedule_requests_connection(first: $first, after: $after, status: $status, phase: $phase) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      nodes {
        cd_rescheduled
        self_tapes_requirement_revision
        id
        phase
        status
        main
        created_at
        checked_in_at
        updated_at
        mediumable_count
        medium_attachments {
          id
          attachment
          modified_attachment
          sort
          tag_list
          primary
          medium {
            file_type
            file_name
            file_size
            file_width
            file_height
          }
        }
        schedule {
          id
          time_in
          time_out
          casting_session {
            casting_location {
              address {
                timezone
              }
            }
          }
        }
        audition {
          id
          sequence_tag
          profile {
            talent {
              first_name
              last_name
            }
            casting_private
            agency {
              id
              name
              country
              state
              full_name
            }
          }
          casting_role {
            name
            project {
              logo
              name
              union
              company {
                name
                addresses {
                  primary
                  location_name
                  address1
                  city_suburb
                }
              }
            }
            self_tapes_requirements
          }
        }
      }
    }
  }
`;
